import { ClassValue } from 'clsx';
import { isNil } from 'lodash';
import { Text } from '@shared/components/Text';
import { SubformField } from '@shared/data/entity/fields/SubformField';
import { useWorkflowTemplate } from '@shared/scenes/workflows/hooks';
import { CollectionViewFieldContainer } from './CollectionViewFieldContainer';
import { FieldVariant } from './FieldVariant';

interface Props {
  variant: FieldVariant;
  className?: ClassValue;
  field: SubformField;
}

/** Default and compact: the subform's name. Inline: the name as text, in the host's size. */
export function SubformCollectionViewField({ field, variant, className }: Props) {
  const { workflowTemplate: queriedWorkflowTemplate } = useWorkflowTemplate(
    isNil(field.workflowTemplate) ? field?.subform.workflowTemplateId : null,
  );
  const workflowTemplate = queriedWorkflowTemplate ?? field.workflowTemplate;

  if (isNil(workflowTemplate) || field.isEmpty) {
    return null;
  }

  return (
    <CollectionViewFieldContainer
      fieldType={field.fieldType}
      variant={variant}
      className={className}
    >
      {variant === 'inline' && workflowTemplate.name}
      {variant !== 'inline' && <Text size="body1">{workflowTemplate.name}</Text>}
    </CollectionViewFieldContainer>
  );
}
